@import "../../../styles/base";

.c-input-label {
  margin-bottom: 0.25rem;
  display: flex;
  justify-content: stretch;
  align-items: flex-end;
  font-size: $ds-font-size-b3;
  font-weight: $ds-font-weight-medium;
  line-height: 1.125rem;

  &--paragraph {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  &__main {
    flex: 1 0 1em;
  }
}
